import {MovieFilter} from "./movie_filter";

export class MovieList {

    private $list;
    private offset;
    private filter;
    private hasMore = true;
    private isLoading = false;

    constructor() {
        this.$list = document.querySelector('.movie-list');
        this.offset = this.getOffset();
        this.filter = new MovieFilter(this);


        this.load();
        this.handleDate();
        this.attachLazyLoad();

        this.$list.addEventListener('click', e => {
            const themeTagClicked = (e.target.classList.contains('tag') && e.target.classList.contains('theme')) || e.target.closest('.tag.theme');
            const introClicked = e.target.classList.contains('intro') || e.target.closest('.intro')

            if (introClicked) {
                if (!themeTagClicked) {
                    e.preventDefault();
                }

                e.target.closest('.movie').classList.toggle('is-active');
            }
        });

        document.querySelectorAll('.views a').forEach($view => {
            $view.addEventListener('click', e => {
                $view.closest('.views').querySelector('a.is-active').classList.remove('is-active');
                $view.classList.add('is-active');

                this.$list.className = $view.dataset.listClasses;
                e.preventDefault();
                this.reset();
                this.load();

                if ('URLSearchParams' in window) {
                    const url = new URL(window.location)
                    url.searchParams.set('view', $view.dataset.view);
                    history.pushState(null, '', url);
                }
            });
        })
    }

    public attachLazyLoad() {
        let options = {
            rootMargin: "0px",
            threshold: 1.0,
        };
        let observer = new IntersectionObserver(entries => {
            entries.forEach(entry => {
                if (entry.isIntersecting && this.hasMore) {
                    this.load()
                }
            });
        }, options);
        observer.observe(document.querySelector('.load-threshold'));
    }

    public load() {
        if (this.isLoading) return;

        this.$list.classList.add('is-loading');

        this.isLoading = true;
        const data = {
            offset: this.offset,
            filter: this.filter.getValues(),
            pageId: window.pageId,
            template: (window.moiveListTemplate) ? window.moiveListTemplate : document.querySelector('.views .is-active').dataset.listTemplate
        };

        fetch(window.loadMoviesUrl, {
            method: 'POST',
            headers: {'Content-Type': 'application/json'},
            body: JSON.stringify(data)
        }).then(response => response.json()).then(data => {
            const html = data.data.html;
            this.hasMore = html !== '';
            this.$list.insertAdjacentHTML('beforeend', html);

            const dates = data.data.dates.map(entry => entry.date);
            this.filter.setDates(dates);

            this.handleDate();
            this.offset = this.getOffset();
            window.ShareButtons.update()
            window.handleVideos();

            this.$list.classList.remove('is-loading');
            this.isLoading = false;
        });
    }

    public reset() {
        this.$list.innerHTML = '';
        this.offset = 0;
        this.load();
    }

    private handleDate() {
        let prevDate = null;
        let i = 0;
        this.$list.querySelectorAll('.list-item').forEach($item => {
            const $date = $item.querySelector('.date');
            const date = $date.dataset.date;

            if (date == prevDate) {
                $date.innerHTML = '';
            } else {
                i++;
            }

            //change bg color for mobile if date is different
            $item.classList.add('bg-' + i % 2);

            prevDate = date;
        });
    }

    public getOffset() {
        return this.$list.querySelectorAll('.movie').length;
    }
}

const bodyClasses = document.body.classList;
if (bodyClasses.contains('template_movie_list') || bodyClasses.contains('template_series_detail')) {
    new MovieList();
}
